import {EDocumentType, EPaymentType} from 'src/containers/User';

import {EDetailsAction, EEntityType} from './definitions';

export default {
  empty: 'Not specified',
  kpp: 'Tax Registration Reason Code (KPP)',
  legalAddress: 'Company address',
  legalAddressHint: "Enter your company's address, which will be displayed on the invoice",
  postAddress: 'Postal address for the document exchange',
  modalTitle: {
    companyDetails: 'company details',
  },
  reminderModal: {
    title: 'You forgot something.',
    text: "We don't have your company details. Please fill in your requisites",
    button: 'Fill in details',
    taxNumberWarning:
      'Please verify that the Taxpayer Identification Number (TIN) is correct. Once saved, the field will be closed for editing.',
    vatNumberWarning:
      'Please verify that the VAT number is correct. Once saved, the field will be closed for editing.',
    blrTaxNumberWarning:
      'Please verify that the Payer’s Account Number (UNP) is correct. Once saved, the field will be closed for editing.',
    binNumberWarning:
      'Please verify that the Business Identification Number (BIN) is correct. Once saved, the field will be closed for editing.',
    entityType: 'Legal form',
    companyDetails: 'Company details',
  },
  entityType: {
    [EEntityType.LEGAL]: 'Legal entity',
    [EEntityType.INDIVIDUAL]: 'Individual entrepreneur',
  },
  contractInfo: 'Contract data and settlement rules',
  countryCode: 'Country',
  companyRequisites: 'Company details',
  companyDetails: 'Company details',
  contactDetails: 'Client`s contact person',
  settlementRules: 'Settlement rules',
  licenseConditions: 'License activation conditions',
  country: 'Country',
  taxNumber: 'Taxpayer Identification Number (TIN)',
  vatNumber: 'VAT number',
  blrTaxNumber: 'Payer’s Account Number (UNP)',
  binNumber: 'Business Identification Number (BIN)',
  ogrn: 'OGRN/OGRNIP code',
  currencyCode: 'Currency',
  accountType: 'Account type',
  documentType: 'Document type',
  documentTypes: {
    [EDocumentType.AGREEMENT]: 'Agreement',
    [EDocumentType.CONTRACT]: 'Contract',
    [EDocumentType.TECH_PARTNER_CONTRACT]: 'Tech partner (contract)',
    [EDocumentType.TECH_PARTNER_OFFER]: 'Tech partner (agreement)',
    [EDocumentType.PILOT]: 'Pilot',
  },
  securityDeposit: 'Security payment amount',
  paymentType: 'Payment type',
  paymentTypes: {
    [EPaymentType.MIXED_PREPAYMENT]: 'Mixed payment',
    [EPaymentType.POSTPAID]: 'Postpayment',
    [EPaymentType.PREPAYMENT]: 'Prepayment',
  },
  contactName: 'Full name',
  phone: 'Phone',
  email: 'Email',
  resellerId: 'Jurisdiction',
  maxOverdraft: 'Overdraft amount',
  managerResponsibleForCheckingId: 'Responsible for the company audit',
  validity: 'Validity period',
  activateLicenseDebt: 'Activate license "on credit"',
  activateLicenseDebtOptions: {
    true: 'Permitted',
    false: 'Forbidden',
  },
  licensePaymentTerm: 'License payment period',
  termBeforeTerminationLicense:
    'Number of days until the license is cancelled in case of non-payment',
  overdraftAgreed: 'Overdraft has been approved by',
  companyName: 'Company name',
  editContactInfo: 'Change client`s contact details?',
  editContactName: 'Full name of company`s contact person',
  siteAddress: 'Website',
  detailsAction: {
    [EDetailsAction.ADD]: 'Add {{detailsName}}',
    [EDetailsAction.FILL]: 'Fill {{detailsName}}',
    [EDetailsAction.UPDATE]: 'Update {{detailsName}}',
  },
  notification:
    'To register channels, fill in the company details in full. You will find your pricing information on the "Pricing" tab.',
};
